import { useState, useRef } from 'react';

import ShiftChangeFormContainer from '../components/Form/ShiftChangeFormContainer';

import '../styles/Table.css';

const initialAttentionPoints = [
    'Pátio IAA com restrição de acesso para caminhões acima de 3 eixos até 18h.',
    'Terminal ZDI operando com 1 moega indisponível para manutenção preventiva.',
    'Aguardando liberação de laudo de qualidade para o lote de milho do pátio IQB.',
]

const initialLastShiftPrefixRows = [
    { prefixo: 'M80', qtdVagas: 84, produto: 'AÇÚCAR', patio: 'IAA', observacao: 'EXEMPLO DE DESCRIÇÃO', status: 'verde'    },
    { prefixo: 'U68', qtdVagas: 84, produto: 'SOJA',    patio: 'ZDI', observacao: 'EXEMPLO DE DESCRIÇÃO', status: 'vermelho' },
    { prefixo: 'M88', qtdVagas: 74, produto: 'MILHO',   patio: 'IQB', observacao: 'EXEMPLO DE DESCRIÇÃO', status: 'laranja'  },
]

const lastShiftTerminalRows = [
    {
        terminal: 'TGG',
        descricao: 'EXEMPLO DE DESCRIÇÃO DE CENÁRIO ATUAL DO TERMINAL',
        status: [
            { cor: 'amarelo', label: 'MILHO' },
            { cor: 'vermelho', label: 'SOJA' },
        ]
    },
]

const statusDotColor = {
    verde:    'bg-verde-floresta-m',
    vermelho: 'bg-red-500',
    laranja:  'bg-amarelo-ouro-e',
    amarelo:  'bg-amarelo-ouro-m',
}

const statusOptions = [
    { value: 'verde',    label: 'Verde'    },
    { value: 'amarelo',  label: 'Amarelo'  },
    { value: 'laranja',  label: 'Laranja'  },
    { value: 'vermelho', label: 'Vermelho' },
]

const emptyPrefixRow = { prefixo: '', qtdVagas: '', produto: '', patio: '', observacao: '', status: 'verde' }
const emptyTerminalRow = { terminal: '', descricao: '', status: '' }

const inputClass = 'w-full rounded-[3px] px-2 py-1 border border-gray-300 text-sm focus:outline-none focus:border-blue-500'

function StatusDot({ cor }) {
    return <span className={`inline-block w-2.5 h-2.5 rounded-full ${statusDotColor[cor]}`} />
}

function EditIcon({ onClick, title }) {
    return (
        <svg
            onClick={onClick}
            title={title}
            className="icone-editar shrink-0 cursor-pointer"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            height="16px"
            fill="var(--cinza-chumbo-m)"
        >
            <path d="M18.656.93,6.464,13.122A4.966,4.966,0,0,0,5,16.657V18a1,1,0,0,0,1,1H7.343a4.966,4.966,0,0,0,3.535-1.464L23.07,5.344a3.125,3.125,0,0,0,0-4.414A3.194,3.194,0,0,0,18.656.93Zm3,3L9.464,16.122A3.02,3.02,0,0,1,7.343,17H7v-.343a3.02,3.02,0,0,1,.878-2.121L20.07,2.344a1.148,1.148,0,0,1,1.586,0A1.123,1.123,0,0,1,21.656,3.93Z"/>
            <path d="M23,8.979a1,1,0,0,0-1,1V15H18a3,3,0,0,0-3,3v4H5a3,3,0,0,1-3-3V5A3,3,0,0,1,5,2h9.042a1,1,0,0,0,0-2H5A5.006,5.006,0,0,0,0,5V19a5.006,5.006,0,0,0,5,5H16.343a4.968,4.968,0,0,0,3.536-1.464l2.656-2.658A4.968,4.968,0,0,0,24,16.343V9.979A1,1,0,0,0,23,8.979ZM18.465,21.122a2.975,2.975,0,0,1-1.465.8V18a1,1,0,0,1,1-1h3.925a3.016,3.016,0,0,1-.8,1.464Z"/>
        </svg>
    )
}

function DeleteIcon({ onClick, title }) {
    return (
        <svg
            onClick={onClick}
            title={title}
            className="icone-deletar shrink-0 cursor-pointer"
            xmlns="http://www.w3.org/2000/svg"
            height="16px"
            viewBox="0 0 24 24"
        >
            <path d="m23,4h-6v-2c0-1.103-.897-2-2-2h-6c-1.103,0-2,.897-2,2v2H1v2h1.644l1.703,15.331c.169,1.521,1.451,2.669,2.982,2.669h9.304c1.531,0,2.813-1.147,2.981-2.669l1.703-15.331h1.682v-2Zm-14-2h6v2h-6v-2Zm8.626,19.11c-.056.507-.483.89-.994.89H7.329c-.51,0-.938-.383-.994-.89l-1.679-15.11h14.65l-1.679,15.11Zm-9.583-4.567l2.543-2.543-2.543-2.543,1.414-1.414,2.543,2.543,2.543-2.543,1.414,1.414-2.543,2.543,2.543,2.543-1.414,1.414-2.543-2.543-2.543,2.543-1.414-1.414Z"/>
        </svg>
    )
}

function DoneIcon({ onClick, title }) {
    return (
        <svg
            onClick={onClick}
            title={title}
            className="shrink-0 cursor-pointer hover:fill-[var(--azul-profundo-m)]"
            xmlns="http://www.w3.org/2000/svg"
            height="16px"
            viewBox="0 0 24 24"
            fill="var(--verde-floresta-m)"
        >
            <path d="M9,19.5c-.256,0-.512-.098-.707-.293L2.939,13.854c-.391-.391-.391-1.023,0-1.414s1.023-.391,1.414,0l4.646,4.646L20.646,5.439c.391-.391,1.023-.391,1.414,0s.391,1.023,0,1.414L9.707,19.207c-.195.195-.451.293-.707.293Z"/>
        </svg>
    )
}

let idCounter = 0
const createId = () => `row-${++idCounter}`

function ShiftChangePage() {

    const [attentionPoints, setAttentionPoints]     = useState(initialAttentionPoints)
    const [editingIndex, setEditingIndex]           = useState(null)
    const inputRef                                  = useRef(null)

    const shiftChangeFormRef = useRef(null)

    const [lastShiftPrefixRows]                                = useState(initialLastShiftPrefixRows)
    const [currentShiftPrefixRows, setCurrentShiftPrefixRows] = useState([])
    const [draggedRow, setDraggedRow]                         = useState(null)
    const [isDragOverCurrent, setIsDragOverCurrent]           = useState(false)
    const [editingCurrentPrefixId, setEditingCurrentPrefixId] = useState(null)

    const [currentShiftTerminalRows, setCurrentShiftTerminalRows]   = useState([])
    const [editingCurrentTerminalId, setEditingCurrentTerminalId]   = useState(null)

    const handleDragStart = (row) => {
        setDraggedRow(row)
    }

    const handleDragEnd = () => {
        setDraggedRow(null)
        setIsDragOverCurrent(false)
    }

    const handleDropOnCurrentShift = (e) => {
        e.preventDefault()
        setIsDragOverCurrent(false)

        if (!draggedRow) return

        setCurrentShiftPrefixRows((rows) => [...rows, { ...draggedRow, id: createId() }])
        setDraggedRow(null)
    }

    const handleAddCurrentPrefixRow = () => {
        const id = createId()
        setCurrentShiftPrefixRows((rows) => [...rows, { ...emptyPrefixRow, id }])
        setEditingCurrentPrefixId(id)
    }

    const handleChangeCurrentPrefixField = (id, field, value) => {
        setCurrentShiftPrefixRows((rows) => rows.map((row) => row.id === id ? { ...row, [field]: value } : row))
    }

    const handleDeleteCurrentPrefixRow = (id) => {
        setCurrentShiftPrefixRows((rows) => rows.filter((row) => row.id !== id))
        if (editingCurrentPrefixId === id) setEditingCurrentPrefixId(null)
    }

    const handleAddCurrentTerminalRow = () => {
        const id = createId()
        setCurrentShiftTerminalRows((rows) => [...rows, { ...emptyTerminalRow, id }])
        setEditingCurrentTerminalId(id)
    }

    const handleChangeCurrentTerminalField = (id, field, value) => {
        setCurrentShiftTerminalRows((rows) => rows.map((row) => row.id === id ? { ...row, [field]: value } : row))
    }

    const handleDeleteCurrentTerminalRow = (id) => {
        setCurrentShiftTerminalRows((rows) => rows.filter((row) => row.id !== id))
        if (editingCurrentTerminalId === id) setEditingCurrentTerminalId(null)
    }

    const handleEditPoint = (index) => {
        setEditingIndex(index)
        setTimeout(() => inputRef.current?.focus(), 0)
    }

    const handleChangePoint = (index, value) => {
        setAttentionPoints((points) => points.map((point, i) => i === index ? value : point))
    }

    const handleAddPoint = () => {
        setAttentionPoints((points) => [...points, ''])
        setEditingIndex(attentionPoints.length)
        setTimeout(() => inputRef.current?.focus(), 0)
    }

    const handleDeletePoint = (index) => {
        setAttentionPoints((points) => points.filter((_, i) => i !== index))
        setEditingIndex((current) => {
            if (current === null) return null
            if (current === index) return null
            return current > index ? current - 1 : current
        })
    }

    return (

        <div className="pg-content flex flex-col gap-4">

            <h1>Passagem de Turno</h1>

            <section className="w-full bg-neutro borda-cinza rounded-[7px] p-[10px] flex justify-between items-center gap-[10px]">

                <input
                    type="date"
                    defaultValue="2026-09-10"
                    className="input-data border border-cinza-chumbo-c rounded-[6px] bg-white px-3 py-1.5 text-sm"
                />

                <button
                    className="btn bg-azul-profundo-m hover:bg-azul-profundo-e h-18 px-8 font-semibold "
                    onClick={() => shiftChangeFormRef.current?.handleModalOpen()}
                >
                    Novo Turno
                </button>

            </section>

            <ShiftChangeFormContainer ref={shiftChangeFormRef} />

            <section className="borda-cinza rounded-[7px] overflow-hidden">

                <header className="bg-azul-profundo-m flex items-center justify-center py-2">
                    <h2 className="text-white text-[1rem] leading-7 font-semibold">PONTOS DE ATENÇÃO</h2>
                </header>

                <div className="bg-white">

                    {attentionPoints.map((point, index) => (

                        <div
                            key={index}
                            className="flex items-center justify-between gap-2 px-3 py-2 border-b borda-cinza last:border-b-0"
                        >

                            {editingIndex === index ? (

                                <input
                                    ref={inputRef}
                                    type="text"
                                    value={point}
                                    onChange={(e) => handleChangePoint(index, e.target.value)}
                                    onBlur={() => setEditingIndex(null)}
                                    onKeyDown={(e) => e.key === 'Enter' && setEditingIndex(null)}
                                    placeholder="Descreva o ponto de atenção"
                                    className="flex-1 text-sm outline-none"
                                />

                            ) : (

                                <span className={`flex-1 text-sm ${!point ? 'text-cinza-chumbo-c italic' : ''}`}>
                                    {point || 'Sem observações'}
                                </span>

                            )}

                            <div className="flex items-center gap-2">
                                <EditIcon onClick={() => handleEditPoint(index)} title="Editar" />
                                <DeleteIcon onClick={() => handleDeletePoint(index)} title="Excluir" />
                            </div>

                        </div>

                    ))}

                    <button
                        type="button"
                        onClick={handleAddPoint}
                        className="w-full text-left text-sm text-azul-profundo-m px-3 py-2 hover:bg-neutro"
                    >
                        + Adicionar ponto de atenção
                    </button>

                </div>

            </section>

            <div className="flex flex-col md:flex-row gap-4">

                <div className="flex-1 flex flex-col gap-2">

                    <h2>Último turno</h2>

                    <table className="table-pattern-sistem w-full borda-cinza">
                        <thead className="bg-azul-profundo-m">
                            <tr className="">
                                <th className="text-white">Prefixo</th>
                                <th className="text-white">Qtd_vagões</th>
                                <th className="text-white">Produto</th>
                                <th className="text-white">Pátio</th>
                                <th className="text-white">Observação</th>
                                <th className="text-white !text-center w-[80px]">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {lastShiftPrefixRows.map((row) => (
                                <tr
                                    key={row.prefixo}
                                    draggable
                                    onDragStart={() => handleDragStart(row)}
                                    onDragEnd={handleDragEnd}
                                    title="Arraste para o Turno Atual"
                                    className={`cursor-grab active:cursor-grabbing select-none ${draggedRow?.prefixo === row.prefixo ? 'opacity-40' : ''}`}
                                >
                                    <td>{row.prefixo}</td>
                                    <td>{row.qtdVagas}</td>
                                    <td>{row.produto}</td>
                                    <td>{row.patio}</td>
                                    <td>{row.observacao}</td>
                                    <td className="!text-center"><StatusDot cor={row.status} /></td>
                                </tr>
                            ))}

                            {lastShiftPrefixRows.length === 0 && (
                                <tr>
                                    <td colSpan={6} className="text-center text-cinza-chumbo-c italic">
                                        Sem vagas pendentes
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                    <table className="table-pattern-sistem w-full borda-cinza">
                        <thead className="bg-azul-profundo-m">
                            <tr>
                                <th className="text-white">Terminal</th>
                                <th className="text-white">Descrição</th>
                                <th className="text-white">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {lastShiftTerminalRows.map((row) => (
                                <tr key={row.terminal}>
                                    <td>{row.terminal}</td>
                                    <td>{row.descricao}</td>
                                    <td>
                                        <div className="flex flex-col gap-1">
                                            {row.status.map((status) => (
                                                <span key={status.label} className="flex items-center gap-1.5">
                                                    <StatusDot cor={status.cor} />
                                                    {status.label}
                                                </span>
                                            ))}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                </div>

                <div className="flex-1 flex flex-col gap-2">

                    <h2>Turno Atual</h2>

                    <div
                        onDragOver={(e) => e.preventDefault()}
                        onDragEnter={() => setIsDragOverCurrent(true)}
                        onDragLeave={() => setIsDragOverCurrent(false)}
                        onDrop={handleDropOnCurrentShift}
                        className={`rounded-[7px] transition-colors ${isDragOverCurrent ? 'ring-2 ring-azul-profundo-m bg-azul-ceu-c' : ''}`}
                    >

                        <table className="table-pattern-sistem w-full borda-cinza">
                        <thead className="bg-azul-profundo-m">
                            <tr className="">
                                <th className="text-white">Prefixo</th>
                                <th className="text-white">Qtd_vagões</th>
                                <th className="text-white">Produto</th>
                                <th className="text-white">Pátio</th>
                                <th className="text-white">Observação</th>
                                <th className="text-white !text-center w-[80px]">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                                {currentShiftPrefixRows.map((row) => {

                                    const isEditing = editingCurrentPrefixId === row.id

                                    return (

                                        <tr key={row.id}>

                                            {isEditing ? (
                                                <>
                                                    <td>
                                                        <input
                                                            className={inputClass}
                                                            value={row.prefixo}
                                                            onChange={(e) => handleChangeCurrentPrefixField(row.id, 'prefixo', e.target.value)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            className={inputClass}
                                                            value={row.qtdVagas}
                                                            onChange={(e) => handleChangeCurrentPrefixField(row.id, 'qtdVagas', e.target.value)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            className={inputClass}
                                                            value={row.produto}
                                                            onChange={(e) => handleChangeCurrentPrefixField(row.id, 'produto', e.target.value)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            className={inputClass}
                                                            value={row.patio}
                                                            onChange={(e) => handleChangeCurrentPrefixField(row.id, 'patio', e.target.value)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            className={inputClass}
                                                            value={row.observacao}
                                                            onChange={(e) => handleChangeCurrentPrefixField(row.id, 'observacao', e.target.value)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <select
                                                            className={inputClass}
                                                            value={row.status}
                                                            onChange={(e) => handleChangeCurrentPrefixField(row.id, 'status', e.target.value)}
                                                        >
                                                            {statusOptions.map((option) => (
                                                                <option key={option.value} value={option.value}>{option.label}</option>
                                                            ))}
                                                        </select>
                                                    </td>
                                                </>
                                            ) : (
                                                <>
                                                    <td>{row.prefixo || <span className="text-cinza-chumbo-c italic">--</span>}</td>
                                                    <td>{row.qtdVagas || <span className="text-cinza-chumbo-c italic">--</span>}</td>
                                                    <td>{row.produto || <span className="text-cinza-chumbo-c italic">--</span>}</td>
                                                    <td>{row.patio || <span className="text-cinza-chumbo-c italic">--</span>}</td>
                                                    <td>{row.observacao || <span className="text-cinza-chumbo-c italic">--</span>}</td>
                                                    <td className="!text-center"><StatusDot cor={row.status} /></td>
                                                </>
                                            )}

                                            <td className="!text-center">
                                                <div className="flex items-center justify-center gap-2">
                                                    {isEditing ? (
                                                        <DoneIcon onClick={() => setEditingCurrentPrefixId(null)} title="Concluir edição" />
                                                    ) : (
                                                        <EditIcon onClick={() => setEditingCurrentPrefixId(row.id)} title="Editar" />
                                                    )}
                                                    <DeleteIcon onClick={() => handleDeleteCurrentPrefixRow(row.id)} title="Excluir" />
                                                </div>
                                            </td>

                                        </tr>
                                    )
                                })}

                                {currentShiftPrefixRows.length === 0 && (
                                    <tr>
                                        <td colSpan={7} className="text-center text-cinza-chumbo-c italic">
                                            Arraste um item do último turno ou adicione uma vaga
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                    </div>

                    <button
                        type="button"
                        onClick={handleAddCurrentPrefixRow}
                        className="self-start text-sm text-azul-profundo-m hover:underline"
                    >
                        + Adicionar 
                    </button>

                    <table className="table-pattern-sistem w-full borda-cinza">
                        <thead className="bg-azul-profundo-m">
                            <tr>
                                <th className="text-white">Terminal</th>
                                <th className="text-white">Descrição</th>
                                <th className="text-white">Status</th>
                                <th className="!text-center w-[60px]"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentShiftTerminalRows.map((row) => {

                                const isEditing = editingCurrentTerminalId === row.id

                                return (

                                    <tr key={row.id}>

                                        {isEditing ? (
                                            <>
                                                <td>
                                                    <input
                                                        className={inputClass}
                                                        value={row.terminal}
                                                        onChange={(e) => handleChangeCurrentTerminalField(row.id, 'terminal', e.target.value)}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        className={inputClass}
                                                        value={row.descricao}
                                                        onChange={(e) => handleChangeCurrentTerminalField(row.id, 'descricao', e.target.value)}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        className={inputClass}
                                                        value={row.status}
                                                        onChange={(e) => handleChangeCurrentTerminalField(row.id, 'status', e.target.value)}
                                                    />
                                                </td>
                                            </>
                                        ) : (
                                            <>
                                                <td>{row.terminal || <span className="text-cinza-chumbo-c italic">--</span>}</td>
                                                <td>{row.descricao || <span className="text-cinza-chumbo-c italic">--</span>}</td>
                                                <td>{row.status || <span className="text-cinza-chumbo-c italic">--</span>}</td>
                                            </>
                                        )}

                                        <td className="!text-center">
                                            <div className="flex items-center justify-center gap-2">
                                                {isEditing ? (
                                                    <DoneIcon onClick={() => setEditingCurrentTerminalId(null)} title="Concluir edição" />
                                                ) : (
                                                    <EditIcon onClick={() => setEditingCurrentTerminalId(row.id)} title="Editar" />
                                                )}
                                                <DeleteIcon onClick={() => handleDeleteCurrentTerminalRow(row.id)} title="Excluir" />
                                            </div>
                                        </td>

                                    </tr>
                                )
                            })}

                            {currentShiftTerminalRows.length === 0 && (
                                <tr>
                                    <td colSpan={4} className="text-center text-cinza-chumbo-c italic">
                                        Sem terminais informados
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                    <button
                        type="button"
                        onClick={handleAddCurrentTerminalRow}
                        className="self-start text-sm text-azul-profundo-m hover:underline"
                    >
                        + Adicionar 
                    </button>

                </div>

            </div>

        </div>

    )
}

export default ShiftChangePage;
